import EmailNotification from 'models/notification/email/EmailNotification';

/**
 * Class representing a submission accepted status email notification.
 * @extends EmailNotification
 */
export default class SubmissionAcceptedEmailNotification extends EmailNotification {
	_type = 'submission-accepted';
}
